import React from 'react';
import Pagination from '../Pagination/Pagination';
import { getAdditionalProps } from '../utils';
var getPagingDataTableProps = getAdditionalProps('dm-table__footer', function (state, rowInfo, column, _ref) {
  var _ref$props = _ref.props,
    loading = _ref$props.loading,
    onPageChange = _ref$props.onPageChange,
    page = _ref$props.page,
    pages = _ref$props.pages,
    paginationLabel = _ref$props.paginationLabel;
  return {
    loading: loading,
    onPageChange: onPageChange,
    page: page,
    pages: pages,
    'aria-label': paginationLabel
  };
});
var PagingFooter = function PagingFooter(props) {
  return props.pages > 1 ? /*#__PURE__*/React.createElement(Pagination, Object.assign({}, props, {
    key: props.page
  })) : null;
};
export default function withPaging() {
  return function (TableComponent) {
    return function (props) {
      return /*#__PURE__*/React.createElement(TableComponent, Object.assign({
        TfootComponent: PagingFooter,
        getTfootProps: getPagingDataTableProps
      }, props));
    };
  };
}